document.addEventListener('DOMContentLoaded', () => {
  // Setup elements
  const dialog = document.getElementById('simDialog');
  const openBtn = document.querySelectorAll('[data-open-sim-dialog]');
  const closeBtn = document.getElementById('closeSimBtn');
  const sectionEl = document.getElementById('shopify-section-dialog-sim');

  // Shopify editor events
  sectionEl.addEventListener('shopify:section:select', () => {
    openSimDialog();
  });

  sectionEl.addEventListener('shopify:section:deselect', () => {
    dialog.close();
  });

  // Open dialog handler
  const openSimDialog = () => {
    dialog.classList.remove('animate-dialog-open');

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      // Fallback for browsers that do not support dialog.showModal()
      dialog.style.display = 'block';
    }

    // Animate the dialog after it's opened
    requestAnimationFrame(() => {
      dialog.classList.add('animate-dialog-open');
    });
  };

  // Open dialog when the event is triggered
  document.body.addEventListener('open-dialog:sim', () => {
    openSimDialog();
  });

  // Open dialog when the open button is clicked
  openBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openSimDialog();
    });
  });

  // Close dialog when the close button is clicked
  closeBtn.addEventListener('click', () => {
    dialog.close();
  });

  // Close dialog when clicking outside of it
  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) {
      dialog.close();
    }
  });
});
